export const BEANSTALK_TILE_SIZE = 160;
export const BEANSTALK_ROW_HEIGHT = BEANSTALK_TILE_SIZE * 2;
export const BEANSTALK_PADDING = BEANSTALK_TILE_SIZE;
export const BEANSTALK_VIRTUAL_THRESHOLD = 30;
export const BEANSTALK_FLOORS_PER_SECTION = 10;

export const vocabularyNoteId = note => String(note.noteId || note.id);
export const vocabularyNoteTitle = note => note.title || note.noteTitle || '';
export const vocabularyNoteCount = note => Math.max(0, Number(note.cardCount ?? note.flashcardCount) || 0);

export function getBeanstalkRows(notes) {
  let position = 1;
  return notes.map((note, index) => {
    const count = vocabularyNoteCount(note);
    const start = count ? Number(note.queueStartPosition) || position : null;
    const row = { note, id: vocabularyNoteId(note), index, count, start, end: count ? start + count - 1 : null,
      visualIndex: notes.length - index - 1, top: BEANSTALK_PADDING + (notes.length - index - 1) * BEANSTALK_ROW_HEIGHT };
    position += count;
    return row;
  });
}

export function getBeanstalkPosition(rows, total, progress) {
  if (!total || !rows.length || !progress || progress.state === 'empty' || progress.state === 'inactive') return null;
  if (progress.state === 'complete') return BEANSTALK_PADDING * 0.75;
  if (progress.position == null || !Number.isFinite(Number(progress.position))) return null;
  const position = Math.max(1, Math.min(total, Number(progress.position)));
  const row = rows.find(item => item.count > 0 && position >= item.start - 0.5 && position <= item.end + 0.5);
  if (!row) return null;
  const fraction = Math.max(0, Math.min(1, (position - row.start + 0.5) / row.count));
  return row.top + BEANSTALK_ROW_HEIGHT * (1 - fraction);
}

export function getVisibleBeanstalkRows(rows, viewportTop, viewportHeight, retainedId) {
  if (rows.length < BEANSTALK_VIRTUAL_THRESHOLD) return rows;
  const first = Math.floor((viewportTop - BEANSTALK_PADDING) / BEANSTALK_ROW_HEIGHT) - 2;
  const last = Math.ceil((viewportTop + viewportHeight - BEANSTALK_PADDING) / BEANSTALK_ROW_HEIGHT) + 2;
  return rows.filter(row => row.id === retainedId || (row.visualIndex >= first && row.visualIndex <= last));
}

// Keep global queue/floor indices intact while rebasing just the displayed art.
export function getBeanstalkSection(rows, total, progress, targetId = null) {
  const position = getBeanstalkPosition(rows, total, progress);
  const progressIndex = progress?.state === 'complete' ? rows.length - 1
    : position === null ? 0 : Math.max(0, rows.findIndex(row => position >= row.top && position <= row.top + BEANSTALK_ROW_HEIGHT));
  const requestedIndex = targetId == null ? -1 : rows.findIndex(row => row.id === targetId);
  const anchor = requestedIndex < 0 ? Math.max(0, progressIndex) : requestedIndex;
  const start = Math.floor(anchor / BEANSTALK_FLOORS_PER_SECTION) * BEANSTALK_FLOORS_PER_SECTION;
  const end = Math.min(rows.length, start + BEANSTALK_FLOORS_PER_SECTION);
  const offset = (rows.length - end) * BEANSTALK_ROW_HEIGHT;
  return {
    start, end,
    rows: rows.slice(start, end).map(row => ({ ...row, top: row.top - offset, visualIndex: end - row.index - 1 })),
    height: (end - start) * BEANSTALK_ROW_HEIGHT + BEANSTALK_PADDING * 2,
    y: position !== null && progressIndex >= start && progressIndex < end ? position - offset : null,
    hasRoot: start === 0,
    hasTop: end === rows.length,
  };
}
